<div #content class='content-container'>
    <ng-content></ng-content>
</div>

